import { useSelectedCompanyStore } from '../stores/selectedCompany.store';
import { useUserCompaniesStore } from '../stores/userCompanies.store';
import { UserCompanyRole } from '@monorepo/shared';
import { AdminDashboard } from '../components/dashboard/AdminDashboard';
import { UserDashboard } from '../components/dashboard/UserDashboard';
import { SubscriptionPaywall } from '../components/subscription/SubscriptionPaywall';
import { useIsCompanyPaywalled } from '../components/subscription/useIsCompanyPaywalled';

export const HomePage = () => {
  const selectedCompanyId = useSelectedCompanyStore((state) => state.selectedCompanyId);
  const companies = useUserCompaniesStore((state) => state.companies);
  const currentUserRole = companies.find((c) => c.id === selectedCompanyId)?.role;
  const { isPaywalled, companyName } = useIsCompanyPaywalled();

  if (isPaywalled) {
    return <SubscriptionPaywall companyName={companyName} />;
  }

  if (
    currentUserRole === UserCompanyRole.SUPER_ADMIN ||
    currentUserRole === UserCompanyRole.SUPER_USER
  ) {
    return <AdminDashboard />;
  }

  return <UserDashboard />;
};
